import { Button } from "@mui/material";
import { DialogModal } from "@zfp-akademie-a-s/zfp-design";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { DialogErrorText } from "./DialogErrorText";
import type { DuplicateConflict } from "./useDuplicateVersion";

type Props = {
  readonly conflict: DuplicateConflict;
};

export const DuplicateConflictDialog = ({ conflict }: Props) => {
  const { t } = useResource();

  return (
    <DialogModal
      size="sm"
      open={conflict.sourceVersion !== null}
      onClose={conflict.cancel}
      isPending={conflict.isConfirming}
      closeLabel={t(Resources.Common.Cancel)}
      title={t(Resources.AnalysisDetail.Duplicate.Conflict.Title)}
      subtitle={t(Resources.AnalysisDetail.Duplicate.Conflict.Text, { version: conflict.sourceVersion?.version })}
      content={conflict.errorText && <DialogErrorText text={conflict.errorText} />}
      secondaryAction={
        conflict.canOpenExisting && (
          <Button variant="contained" color="secondary" disabled={conflict.isConfirming} onClick={conflict.openExisting}>
            {t(Resources.AnalysisDetail.Duplicate.Conflict.OpenExisting)}
          </Button>
        )
      }
      primaryAction={
        <Button variant="contained" loading={conflict.isConfirming} onClick={conflict.confirm}>
          {t(Resources.AnalysisDetail.Duplicate.Conflict.Confirm)}
        </Button>
      }
    />
  );
};
